<template>
  <v-text-field
    v-bind="_props"
    :error-messages="$errors(inner)"
    :counter="innerCounter"
    v-model="inner.$model"
    :label="labelText"
    @focus="focus"
    @input="input"
    :typeField="type"
    :readonly="readonly"
  />
</template>

<script>
import VuetifyInputExt from '@/plugins/mixins/VuetifyInputExt'
export default {
  mixins: [VuetifyInputExt],
  props: {
    appendOuterIcon: String,
    autofocus: Boolean,
    filled: Boolean,
    browserAutocomplete: String,
    clearable: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
    clearIcon: {
      type: String,
      default: '$vuetify.icons.clear',
    },
    clearIconCb: Function,
    color: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'text',
    },
    counter: [Boolean, Number, String],
    flat: Boolean,
    fullWidth: Boolean,
    hidden: Boolean,
    label: String,
    outline: Boolean,
    placeholder: String,
    prefix: String,
    prependInnerIcon: String,
    disabled: Boolean,
    reverse: Boolean,
    singleLine: Boolean,
    solo: Boolean,
    soloInverted: Boolean,
    suffix: String,
    typeField: {
      type: String,
      default: 'text',
    },
    mask: String,
  },
  computed: {
    innerCounter() {
      if (this.counter) {
        return this.counter
      }

      if (this.inner.maxLength) {
        return this.inner.$params.maxLength
      }

      return null
    },
  },
  methods: {
    focus() {
      this.$emit('focus')
    },
    input(event) {
      this.$emit('input', event)
    },
  },
}
</script>
